import Summary from "./index";
import Others from "./others";
import SelfIntroduction from "./selfIntroduction";
import Projects from "./projects";
import {useEffect, useRef} from "react";

const AllSummary = () => {

    const activeTarget = 'choice-summary-4';
    const focusRef = useRef();
    useEffect(() => {
        document.querySelector(`#${activeTarget}`)?.classList?.add('border-primary');
        focusRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    },[])

    return (<>
        <Summary/>
        <div ref={focusRef}>
            <Others allMode/>
            <SelfIntroduction allMode/>
            <Projects allMode/>
        </div>
    </>);
}

export default AllSummary;